import { ExamEventErrorCode } from '@exam-center/graphql';

export const EXAM_EVENT_CREATION_ERROR_MESSAGE_MAP: Partial<Record<ExamEventErrorCode, string>> = {
  [ExamEventErrorCode.WebRegisterConfigurationNotFound]:
    'ไม่สามารถสร้างรอบสอบได้ เนื่องจากศูนย์สอบนี้ยังไม่ได้เชื่อมต่อระบบ WR',
};
